import { post, get } from '../utils/fetch';

// 文创商城的API
export default class MallService {
    // 文创商城所有分类
    static fetchCategoryList(params) {
        return post('/api/v1/dynamic/query', params)
    }

    // 每个分类下的商品
    static fetchCategoryGoodsList(params) {
        return get('/api/v1/dynamic/pageQuery', params)
    }

}




// WEBPACK FOOTER //
// ./src/api/mallService.js